import { createAction } from 'redux-actions';

import { REQUEST_SIZE, RESULTS_LIMIT } from 'constants/general';
import dialog from 'features/common/dialog';
import fetch from 'features/common/fetch';
import { searchUserTypes } from 'features/other/resolverSettings/constants';

import { MARKET_PLACE_AGENCIES_SETTINGS_FORM_NAME } from '../settings/marketPlaceAgencies/form';
import { CLEAR_SEARCH, SET_USERS, SET_USERS_APPEND } from './actionTypes';
import { dialogError } from './constants';
import { removeNulls } from './utils';

const setUsers = createAction(SET_USERS, (response) => response);

const setUsersAppend = createAction(SET_USERS_APPEND, (response) => response);

export const searchUser =
	({ type, formData, page = 0, append = false }) =>
	async (dispatch, getState, { getFormData }) => {
		const { login, firstName, surname, sellerIn } = formData;

		let finalQueryParams;
		let finalUrl;

		// resolverSettings - taskCreatingPages, taskForwarding
		if (type === searchUserTypes.USER_LIST_SEARCH) {
			finalQueryParams = {
				login,
				sellerIn,
				firstName,
				surname,
				sort: ['surname,asc', 'firstName,asc'],
				size: REQUEST_SIZE,
				page,
				userHierarchy: 'none',
			};

			finalUrl = fetch.constants.urls.userList;
		}

		let regionId;
		// user search in MarketPlaceAgencies - EditAgencyModal
		if (type === searchUserTypes.MARKET_PLACE_AGENCIES_SEARCH) {
			finalQueryParams = {
				userLogin: login,
				sellerIn,
				firstName,
				surname,
			};

			finalUrl = fetch.constants.urls.settingsMarketPlaceAgenciesSearchUser;
			const formData = await getFormData(MARKET_PLACE_AGENCIES_SETTINGS_FORM_NAME);
			regionId = formData?.region;
		}

		return dispatch(
			fetch.actions.get(finalUrl, {
				...(type === searchUserTypes.MARKET_PLACE_AGENCIES_SEARCH && { replaceParams: { regionId } }),
				queryParams: removeNulls(finalQueryParams),
				onSuccess: [
					(response) => () => {
						if (!response || !response.body) return;

						if (type === searchUserTypes.USER_LIST_SEARCH) {
							if (response.body.pageMetaData.totalRows > RESULTS_LIMIT) {
								dispatch(dialog.actions.open(dialogError, null, dialog.constants.ERROR));
							} else {
								if (append) {
									dispatch(setUsersAppend(response.body.data));
								} else {
									dispatch(setUsers(response.body.data));
									return response.body.data;
								}
							}
						}

						if (type === searchUserTypes.MARKET_PLACE_AGENCIES_SEARCH) {
							dispatch(setUsers(response.body));
						}
					},
				],
			}),
		);
	};

export const clearSearch = createAction(CLEAR_SEARCH);

export const loadeMore = (formData, page) => searchUser(formData, page, true);
